"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDefaults = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const api = axios_1.default.create();
exports.default = api;
const setDefaults = (overrideConfig) => {
    return api.interceptors.request.use(async (config) => {
        return {
            ...config,
            ...overrideConfig,
        };
    });
};
exports.setDefaults = setDefaults;
//# sourceMappingURL=index.js.map